import {forwardRef} from 'react';

import {Container} from '@/components/HotelsPageLayoutContent/components/Container';
import {LayoutTwoColumn} from '@/components/LayoutTwoColumn';

type Props = {
  main: React.ReactNode;
  aside: React.ReactNode;
  top?: React.ReactNode;
  banners: React.ReactNode;
};

export const HotelsPageLayoutContent = forwardRef<HTMLDivElement, Props>(
  function ContentComponent({main, aside, top, banners}, ref) {
    return (
      <Container ref={ref} spacingBottom>
        {top}
        <LayoutTwoColumn main={main} aside={aside} />
        {banners}
      </Container>
    );
  }
);
